module.exports = __webpack_public_path__ + "img/outdoor.a339e553.png";